import React, { useEffect, useRef } from "react";
import styles from "./AdditionalService.module.css";
import { Camera, PartyPopper, Martini, Disc } from "lucide-react";
import { ADDITIONAL_SERVICE_CONTENT } from "../../Constants";
import { useNavigate } from "react-router-dom";

const AdditionalService = () => {
  const cardsRef = useRef([]);
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/contact");
  };

  // Keep icons inside component (since they are JSX)
  const servicesWithIcons = [
    {
      icon: <PartyPopper size={48} strokeWidth={1.5} style={{ backgroundColor: 'transparent' }} />,
      ...ADDITIONAL_SERVICE_CONTENT.services[0],
    },
    {
      icon: <Camera size={48} strokeWidth={1.5} style={{ backgroundColor: 'transparent' }} />,
      ...ADDITIONAL_SERVICE_CONTENT.services[1],
    },
    {
      icon: <Martini size={48} strokeWidth={1.5} style={{ backgroundColor: 'transparent' }} />,
      ...ADDITIONAL_SERVICE_CONTENT.services[2],
    },
    {
      icon: <Disc size={48} strokeWidth={1.5} style={{ backgroundColor: 'transparent' }} />,
      ...ADDITIONAL_SERVICE_CONTENT.services[3],
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.show);
          }
        });
      },
      { threshold: 0.25 }
    );

    cardsRef.current.forEach((el) => el && observer.observe(el));
  }, []);

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* LEFT */}
        <div className={`${styles.left} ${styles.fadeLeft}`}>
          <h2>{ADDITIONAL_SERVICE_CONTENT.heading}</h2>

          <p>{ADDITIONAL_SERVICE_CONTENT.description}</p>

          <button className={styles.btn} onClick={handleNavigate}>
            {ADDITIONAL_SERVICE_CONTENT.buttonText}
          </button>
        </div>

        {/* RIGHT */}
        <div className={styles.grid}>
          {servicesWithIcons.map((service, index) => (
            <div
              key={index}
              ref={(el) => (cardsRef.current[index] = el)}
              className={styles.card}
              style={{ transitionDelay: `${index * 120}ms` }}
            >
              <div className={styles.icon}>{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdditionalService;